var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',[_c('dynamic-table-ag-grid',{ref:"ordersTable",attrs:{"table-key":"ct_key_orders_table","endpoint":"orders","records-per-page":100}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }